<template lang="pug">
    div
        component(
            v-if="currentComponent"
            :is="currentComponent"
            ref="editPageComponent"
        )
</template>

<script>
export default {
    name: 'EditPageIndex',
    data() {
        return {
            components: {
                'PY': () =>
                    import(
                        '@/modules/traceability-report/views/pages/edit/content.vue'
                    )
            }
        };
    },
    computed: {
        currentComponent() {
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    }
};
</script>

<style scoped lang="scss">

</style>
